module.exports = __webpack_public_path__ + "media/img/pages/companies/stadt-zürich-45ef002a3843bba67bd0fdc33dfdb9f3.png";